<article>
  <div class="p-3">
    <div class="contact-department contact-office">
      <div class="row no-gutters">
        <div class="col-md-12">
          <h2>Contact Office</h2>
          <div class="container">
            <div class="row no-gutters mt-4">
              <div class="col-md-12 col-lg-4 large-res-item">
                <div class="contact-list">
                  <div class="icon-wrapper"><a target="_blank" href="https://goo.gl/maps/dh5UDx5E1UvVCjKy8"><i class="fas fa-map-marker-alt"></i></a></div>
                  <h3>Head Office : <br> <span>Dillibazaar, Kathmandu Nepal</span></h3>
                </div>
              </div>
              <div class="col-md-12 col-lg-4 large-res-item">
                <div class="contact-list">
                  <div class="icon-wrapper"> <a href="tel:01-4544216"><i class="fas fa-phone-alt"></i></a> </div>
                  <h3>Phone : <br> <span><a href="tel:01-4544216">01-4544217</a> / <a href="tel:01-4516468">01-4516468</a></span></h3>
                </div>
              </div>
              <div class="col-md-12 col-lg-4 large-res-item">
                <div class="contact-list">
                  <div class="icon-wrapper"><a href="mailto:support.imark@imark.com.np"><i class="fas fa-envelope"></i></a></div>
                  <h3>Email : <br> <span><a href="mailto:support.imark@imark.com.np">support.imark@imark.com.np</a></span></h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="contact-department operation-department">
      <div class="row no-gutters">
        <div class="col-md-12">
          <h2>Paytech Operation Department</h2>
          <mat-tab-group class="mt-3">
            <mat-tab label="FIRST POINT PERSONAL CONTACT">
            <p>Ticket Type : <span>POS Technical Support</span> </p>
              <div class="support-table-list support-executive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.N</th>
                      <th scope="col">Location</th>
                      <th scope="col">Valley</th>
                      <th scope="col">Executive Name</th>
                      <th scope="col">Contact No</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>

                  <tbody>
                   
                    <tr>
                      <th scope="row">1</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sudip Ligal</td>
                      <td><a href="tel:9802321900">9802321900</a></td>
                      <td><a href="mailto:sudip.ligal@imark.com.np">sudip.ligal@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">2</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sudip Tandukar</td>
                      <td><a href="tel:9802321896">9802321896</a></td>
                      <td><a href="mailto:sudiptandukar@imarkdigital.com">sudiptandukar@imarkdigital.com</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Amar Rai </td>
                      <td><a href="tel:9802312019">9802312019</a></td>
                      <td><a href="mailto:amar.rai@imark.com.np ">amar.rai@imark.com.np </a></td>
                    </tr>

                    <tr>
                      <th scope="row">4</th>
                      <td>Pokhara, Kaski</td>
                      <td>Outside Valley</td>
                      <td>Ashim Bastola </td>
                      <td><a href="tel:9802815252">9802815252</a></td>
                      <td><a href="mailto:ashim.bastola@imark.com.np">ashim.bastola@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">5</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Ati Ullah Ansari </td>
                      <td><a href="tel:9802316498">9802316498</a></td>
                      <td><a href="mailto:atiullah.ansari@imark.com.np">atiullah.ansari@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">6</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Bhim Prasad Neupane </td>
                      <td><a href="tel:9802314725">9802314725</a></td>
                      <td><a href="mailto:bhim.neupane@imark.com.np">bhim.neupane@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">7</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Bijay Shrestha </td>
                      <td><a href="tel:9802321898">9802321898</a></td>
                      <td><a href="mailto:bijay.shrestha@imark.com.np">bijay.shrestha@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Khimananda Paudel</td>
                      <td><a href="tel:9802335509">9802335509</a></td>
                      <td><a href="mailto:khim.paudel@imark.com.np">khim.paudel@imark.com.np</a></td>
                    </tr>


                    <tr>
                      <th scope="row">19</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Manish Upreti</td>
                      <td><a href="tel:9802316497">9802316497</a></td>
                      <td><a href="mailto:manish.upreti@imark.com.np">manish.upreti@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">10</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Mingbar Shyoungba </td>
                      <td><a href="tel:9802321899">9802321899</a></td>
                      <td><a href="mailto:mingbar.shyoungba@imark.com.np">mingbar.shyoungba@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">11</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Mukesh Shrestha</td>
                      <td><a href="tel:9801161034">9801161034</a></td>
                      <td><a href="mailto:mukesh.shrestha@imark.com.np">mukesh.shrestha@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">12</th>
                      <td>Birgunj, Parsa</td>
                      <td>Outside Valley</td>
                      <td>Pramod Chaudhary</td>
                      <td><a href="tel:9801161036">9801161036</a></td>
                      <td><a href="mailto:pramod.chaudhary@imark.com.np">pramod.chaudhary@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td>Bharatpur, Chitwan</td>
                      <td>Outside Valley</td>
                      <td> Aayushman Singh Shrestha </td>
                      <td><a href="tel:9802335504">9802335504</a></td>
                      <td><a href="mailto:Aayushman.shrestha@imark.com.np">Aayushman.shrestha@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">14</th>
                      <td>Nepalgunj, Banke</td>
                      <td>Outside Valley</td>
                      <td> Abhishek Kumar Lakher</td>
                      <td><a href="tel:9802335507">9802335507</a></td>
                      <td><a href="mailto:Abhishek.lakher@imark.com.np">Abhishek.lakher@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">15</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Asmita Lamsal</td>
                      <td><a href="tel:9801161035">9801161035</a></td>
                      <td><a href="mailto:asmita.lamsal@imark.com.np">asmita.lamsal@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Avishek Thakuri</td>
                      <td><a href="tel:9802335508">9802335508</a></td>
                      <td><a href="mailto:avishek.thakuri@imark.com.np">avishek.thakuri@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">17</th>
                      <td>Rupandehi, Lumbini</td>
                      <td>Outside Valley</td>
                      <td>Basanta Bashyal</td>
                      <td><a href="tel:9802321904">9802321904</a></td>
                      <td><a href="mailto:bashanta.bashyal@imark.com.np">bashanta.bashyal@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">18</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Binod Gaudel</td>
                      <td><a href="tel:9802322909">9802322909</a></td>
                      <td><a href="mailto:binod.gaudel@imark.com.np">binod.gaudel@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td>Itahari, Sunsari</td>
                      <td>Outside Valley</td>
                      <td>Dev Raj Pokhrel</td>
                      <td><a href="tel:9802335505">9802335505</a></td>
                      <td><a href="mailto:devraj.pokharel@imark.com.np">devraj.pokharel@imark.com.np</a></td>
                    </tr>

                    
                    <tr>
                      <th scope="row">20</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Ghanshyam Pandey</td>
                      <td><a href="tel:9802844997">9802844997</a></td>
                      <td><a href="mailto:ghanshyam.pandey@imark.com.np">ghanshyam.pandey@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">21</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Hira Kumar Thapa</td>
                      <td><a href="tel:9801061049">9801061049</a></td>
                      <td><a href="mailto:hira.thapa@imark.com.np">hira.thapa@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">22</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Jagat Badhur Singh</td>
                      <td><a href="tel:9802314724">9802314724</a></td>
                      <td><a href="mailto:jagat.singh@imark.com.np">jagat.singh@imark.com.np</a></td>
                    </tr>
                    
                    <tr>
                      <th scope="row">23</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Kapildev Karki</td>
                      <td><a href="tel:9801161031">9801161031</a></td>
                      <td><a href="mailto:kapil.karki@imark.com.np">kapil.karki@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">24</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Kushal Shakya</td>
                      <td><a href="tel:9801292954">9801292954</a></td>
                      <td><a href="mailto:kushal.shakya@imark.com.np">kushal.shakya@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">25</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Manju Magar</td>
                      <td><a href="tel:9802311801">9802311801</a></td>
                      <td><a href="mailto:manju.magar@imark.com.np">manju.magar@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">26</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Manoj Lama</td>
                      <td><a href="tel:9802318102">9802318102</a></td>
                      <td><a href="mailto:manoj.lama@imark.com.np">manoj.lama@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">27</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Prabin Khadka</td>
                      <td><a href="tel:9802334118">9802334118</a></td>
                      <td><a href="mailto:prabin.khadka@imark.com.np">prabin.khadka@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Pradip Khadka</td>
                      <td><a href="tel:9802334119">9802334119</a></td>
                      <td><a href="mailto:Pradip.Khadka@imark.com.np">Pradip.Khadka@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Raju Chaudary</td>
                      <td><a href="tel:9801061048">9801061048</a></td>
                      <td><a href="mailto:raju.chaudhary@imark.com.np">raju.chaudhary@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">30</th>
                      <td>Birtamode, Jhapa</td>
                      <td>Outside Valley</td>
                      <td>Prashish Lamsal</td>
                      <td><a href="tel:9802335506">9802335506</a></td>
                      <td><a href="mailto:Prashish.lamsal@imark.com.np">Prashish.lamsal@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">31</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Priya Dahal</td>
                      <td><a href="tel:9802314714">9802314714</a></td>
                      <td><a href="mailto:priya.dahal@imark.com.np">priya.dahal@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">32</th>
                      <td>Pokhara, Kaski</td>
                      <td>Outside Valley</td>
                      <td>Rajesh Adhikari</td>
                      <td><a href="tel:9802855259">9802855259</a></td>
                      <td><a href="mailto:rajesh.adhikari@imark.com.np">rajesh.adhikari@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">33</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sampurna Lama</td>
                      <td><a href="tel:9802314733">9802314733</a></td>
                      <td><a href="mailto:sampurna.lama@imark.com.np">sampurna.lama@imark.com.np </a></td>
                    </tr>

                    <tr>
                      <th scope="row">34</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sarad Shrestha</td>
                      <td><a href="tel:9802335502">9802335502</a></td>
                      <td><a href="mailto:sarad.shrestha@imark.com.np">sarad.shrestha@imark.com.np </a></td>
                    </tr>

                    <tr>
                      <th scope="row">35</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Suraj Chaudhary</td>
                      <td><a href="tel:9802335510">9802335510</a></td>
                      <td><a href="mailto:suraj.chaudhary@imark.com.np">suraj.chaudhary@imark.com.np </a></td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </mat-tab>

            <mat-tab label="FIRST LEVEL ESCALATION">
              <div class="support-table-list support-supervisors">
                <p>Ticket Type :  <span>POS Technical Support & Management</span> </p>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.N</th>
                      <th scope="col">Location</th>
                      <th scope="col">Valley</th>
                      <th scope="col">Supervisors Name</th>
                      <th scope="col">Contact No</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Amrit Lamsal</td>
                      <td><a href="tel:9802321897">9802321897</a></td>
                      <td><a href="mailto:amrit.lamsal@imark.com.np">amrit.lamsal@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">2</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Bhagbat K.C.</td>
                      <td><a href="tel:9801061047">9801061047</a></td>
                      <td><a href="mailto:bhagbat.kc@imark.com.np">bhagbat.kc@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sagar K.C.</td>
                      <td><a href="tel:9801161038">9801161038</a></td>
                      <td><a href="mailto:sagar.kc@imark.com.np">sagar.kc@imark.com.np</a></td>
                    </tr>

                    <tr>
                      <th scope="row">4</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sanam Singh Maharjan </td>
                      <td><a href="tel:9801061046">9801061046</a></td>
                      <td><a href="mailto:sanam.maharajan@imark.com.np">sanam.maharajan@imark.com.np</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>

            <mat-tab label="SECOND LEVEL ESCALATION">
              <div class="support-table-list support-head">
                <p>Ticket Type :  <span>High Level Communications</span> </p>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.N</th>
                      <th scope="col">Location</th>
                      <th scope="col">Valley</th>
                      <th scope="col">Name</th>
                      <th scope="col">Contact No</th>
                      <th scope="col">Email</th>
                      <th scope="col">Designation</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sagar Pokharel</td>
                      <td><a href="tel:9801033357">9801033357</a></td>
                      <td><a href="mailto:sagar.pokharel@imark.com.np">sagar.pokharel@imark.com.np</a></td>
                      <td>COO</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Madan Acharya </td>
                      <td><a href="tel:9801161033">9801161033</a></td>
                      <td><a href="mailto:madan.acharya@imark.com.np">madan.acharya@imark.com.np</a></td>
                      <td>Manager</td>
                    </tr>

                    <tr>
                      <th scope="row">3</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Madhav Pandey</td>
                      <td><a href="tel:9802322910">9802322910</a></td>
                      <td><a href="mailto:madhav.pandey@imark.com.np">madhav.pandey@imark.com.np</a></td>
                      <td>Manager</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="CARD PERSO">
              <div class="support-table-list support-head">
                <p>Ticket Type :  <span>Card Perso</span> </p>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.N</th>
                      <th scope="col">Location</th>
                      <th scope="col">Valley</th>
                      <th scope="col">Name</th>
                      <th scope="col">Contact No</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Amrit Maharajan</td>
                      <td><a href="tel:9802314735">9802314735</a></td>
                      <td><a href="mailto:amrit.maharjan@imark.com.np">amrit.maharjan@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Divash Bista </td>
                      <td><a href="tel:9802314721">9802314721</a></td>
                      <td><a href="mailto:divash.bista@imark.com.np">divash.bista@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Inoj Regmi</td>
                      <td><a href="tel:9802314723">9802314723</a></td>
                      <td><a href="mailto:inoj.regmi@imark.com.np">inoj.regmi@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Manoj Sapkota</td>
                      <td><a href="tel:9802314726">9802314726</a></td>
                      <td><a href="mailto:manoj.sapkota@imark.com.np">manoj.sapkota@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Rajesh Rana</td>
                      <td><a href="tel:9801292957">9801292957</a></td>
                      <td><a href="mailto:rajesh.rana@imark.com.np">rajesh.rana@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Sasmit Poudel</td>
                      <td><a href="tel:9802852220">9802852220</a></td>
                      <td><a href="mailto:sasmit.poudel@imark.com.np">sasmit.poudel@imark.com.np</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="HARDWARE & CARD PERSO">
              <div class="support-table-list support-head">
                <p>Ticket Type :  <span>Hardware and Card Perso</span> </p>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.N</th>
                      <th scope="col">Location</th>
                      <th scope="col">Valley</th>
                      <th scope="col">Name</th>
                      <th scope="col">Contact No</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Birkha Bdr Kadayat</td>
                      <td><a href="tel:9802314717">9802314717</a></td>
                      <td><a href="mailto:brikha.kadayat@imrk.com.np">brikha.kadayat@imrk.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Kundan Chaudhary</td>
                      <td><a href="tel:9802329998">9802329998</a></td>
                      <td><a href="mailto:kundan.chaudhary@imark.com.np">kundan.chaudhary@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Rohit KC</td>
                      <td><a href="tel:9802314736">9802314736</a></td>
                      <td><a href="mailto:rohit.kc@imark.com.np">rohit.kc@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Samyak Ratna Shakya</td>
                      <td><a href="tel:9802314738">9802314738</a></td>
                      <td><a href="mailto:samyak.shakya@imark.com.np">samyak.shakya@imark.com.np</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td>Head Office, Kathmandu</td>
                      <td>Inside Valley</td>
                      <td>Uttam Bhandari</td>
                      <td><a href="tel:9801161039">9801161039</a></td>
                      <td><a href="mailto:uttam.bhandari@imark.com.np">uttam.bhandari@imark.com.npp</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</article>
